export default "__VITE_ASSET__DUxStBMF__"